export default {
    RoleManagement: {
        common: {
            RoleName: '角色名称',
            Status: '状态',
            create: '创建角色',
            editsome: '编辑角色',
            users: '分配用户',
            menu: '分配菜单权限',
            Log: '日志',
            describe: '描述',
            button: '按钮',
            ps: '请输入角色名称',
        },
        table: {
            RoleName: '角色名称',
            tenantName: '所属租户',
            creator: '创建人',
            Status: '状态',
            operate: '操作',
        },
        child: {
            name: '角色名称',
            add: '添加用户',
            role: '用户账号',
            rolename: '用户名称',
            filter: '输入关键字进行过滤',
        },
        roleNameExists: '角色名称已存在'
    }
};
